<template>
  <div class="wt-asset-editor-layout-overlay">
    <div class="-stp-spinner wt2-sg" v-if="showSpinner">
      <wt-google-like-loader class="-default" />
    </div>
    <img :src="cdnUrl" v-if="shouldShow" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      cdnUrl: null,
      showSpinner: false,
    };
  },
  components: {},
  props: {
    sceneLayoutSTPModel: {
      type: Object,
      default: null,
      required: false,
    },
  },
  computed: {
    shouldShow() {
      return this.cdnUrl;
    },
  },
  mounted() {
    if (this.sceneLayoutSTPModel) {
      if (!this.sceneLayoutSTPModel.isDone()) {
        this.watchSTPModel();
      } else {
        this.stpModelHasData();
      }
    }
  },
  beforeDestroy: function () {
    if (this.sceneLayoutSTPModel) {
      this.sceneLayoutSTPModel.off(
        'change:realTimeFetchProgress change:status',
        this.updateRTPStatus
      );
      this.sceneLayoutSTPModel.off(
        'change:realTimePreviewResultData',
        this.stpModelHasData
      );
    }
  },
  methods: {
    watchSTPModel() {
      this.showSpinner = true;
      this.sceneLayoutSTPModel.on(
        'change:realTimePreviewResultData',
        this.stpModelHasData
      );
      this.sceneLayoutSTPModel.on(
        'change:realTimeFetchProgress cchange:status',
        this.updateRTPStatus
      );
    },
    stpModelHasData() {
      this.showSpinner = false;
      if (this.sceneLayoutSTPModel.isDone()) {
        this.cdnUrl = this.sceneLayoutSTPModel.get(
          'realTimePreviewResultData'
        )?.cdnUrl;
      }
    },
  },
  watch: {
    sceneLayoutSTPModel: function () {
      this.cdnUrl = null;
      this.showSpinner = false;
      if (this.sceneLayoutSTPModel) {
        if (!this.sceneLayoutSTPModel.isDone()) {
          this.watchSTPModel();
        } else {
          this.stpModelHasData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-asset-editor-layout-overlay {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  img {
    position: absolute;
    top: 0;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
  .-stp-spinner {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.15);
    flex-grow: 1;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .wt2-google-like-loader {
      opacity: 1;
      width: 25px;
    }
  }
}
</style>
